




























































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { Button } from 'vant';
import AliPayButton from './AliPayButton.vue';
import { namespace, State, Mutation } from 'vuex-class';
const yuShangModule = namespace('yuShang');
interface IAmountConf {
  id: number;
  money: number;
}

const defaultValue: IAmountConf[] = [
  {
    id: 1,
    money: 0.01,
  },
  {
    id: 2,
    money: 2,
  },
  {
    id: 3,
    money: 4,
  },
  {
    id: 4,
    money: 6,
  },
  {
    id: 5,
    money: 8,
  },
  {
    id: 6,
    money: 10,
  },
];

Vue.use(Button);
@Component({
  components: {
    Button,
    AliPayButton,
  },
})
export default class TopUpComp extends Vue {
  @yuShangModule.State('userId') userId: any;
  @yuShangModule.State('activityId') activityId: any;
  @yuShangModule.State('userInfo') userInfo: any;
  @yuShangModule.State('activityInfo') activityInfo: any;
  amountArr = defaultValue;
  inputMoney: number | string = '';
  activeClass = -1;
  selectMoney = 0;
  subject = '文旅评选C币购买';
  // 活动未开始/已结束不能充值
  get canPay() {
    const startTime = this.activityInfo.startTime;
    const endTime = this.activityInfo.endTime;
    const now = Date.now();
    if (now < +startTime * 1000 || now > +endTime * 1000) {
      return false;
    }
    return true;
  }

  get topUpMoney() {
    if (this.inputMoney) {
      const moneyList = this.amountArr.map((item: IAmountConf) => item.money);
      if (!moneyList.includes(Number(this.inputMoney))) {
        this.activeClass = -1;
      }
      return Number(this.inputMoney);
    } else if (this.activeClass !== -1) {
      return this.selectMoney;
    } else {
      return 0;
    }
  }

  handleAmountClick(index: number, money: number) {
    this.selectMoney = money;
    this.inputMoney = money;
    this.activeClass = index;
  }
  handleInput(e: any) {
    if (process.env.VUE_APP_ENV_NAME === 'production') {
      e.target.value = e.target.value.replace(/^(0)/g, '');
      e.target.value = e.target.value.replace(/\D/g, '');
    }
  }
  testInput(e: any) {
    if (process.env.VUE_APP_ENV_NAME === 'production') {
      const key = e.data || '';
      if (key === '.') {
        e.preventDefault();
      }
    }
  }
}
